export default __webpack_public_path__ + "static/media/DS28.894e2cf3.JPG";